export default {"src":"/_next/static/media/ICT_Solution.fd0f6a5f.svg","height":284,"width":284};